<as-split class="listing" direction="horizontal" [gutterSize]="18">
  <as-split-area [size]="30">
        <div class="tree-node" (click)="openDatasetImportDialog()">
      <button mat-icon-button>
        <mat-icon svgIcon="upload"></mat-icon>
      </button>
      <span class="name">Import</span>
    </div>

    <div class="dataset-listing-tree">
      <mood-tree-node [showMenu]="false" entryIcon="folder-wrench" [entryClicked]="datasetClickedString"
        *ngFor="let node of covariateList" [node]="node"></mood-tree-node>
    </div>
  </as-split-area>

  <as-split-area [size]="70">
    <ng-container *ngIf="selectedCovariateId">
      <mood-admin-covariate-form [covariateId]="selectedCovariateId"></mood-admin-covariate-form>
    </ng-container>
  </as-split-area>
</as-split>
